<template>
  <div id="app">
    <div class="huabu">
		<router-view></router-view>
	</div>
  </div>
</template>

<script>
	import { injectDingtalkMagicOrb } from '@/utils/dingtalk'

	export default {
		name: 'app',
		data() {
			return {
				
			}	
		},
		mounted() {
			injectDingtalkMagicOrb()
		}

	}
</script>
<style  lang="less">
	@l:#57ACA7;
	@L:@l;
	.mgT0 {
	  margin-top: 0!important;
	}
	.mgT5 {
	  margin-top: 5px;
	}
	.mgT20 {
	  margin-top: 20px!important;
	}
	.mgT30 {
	  margin-top: 30px!important;
	}
	.mgL10 {
	  margin-left: 10px;
	}
	.mgR10 {
	  margin-right: 10px;
	}
	.mgR15 {
	  margin-right: 15px;
	}
	.mgL20 {
	  margin-left: 20px;
	}
	.mgR20 {
	  margin-right: 20px;
	}
	.pdT20 {
	  padding-top: 20px;
	}
	.pdB20 {
	  padding-bottom: 20px;
	}
	.w80PX {
	  width: 80px;
	}
	.f40 {
	  font-size: 40px;
	}
	.f16 {
	  font-size: 16px!important;
	}
	.price-text {
	  font-size: 16px!important;
	}
	.price-small-text {
	  font-size: 14px!important;
	}
	.f14 {
	  font-size: 14px;
	}
	.f18 {
	  font-size: 18px;
	}
	.fontbold {
	  font-weight: bold;
	}
	.f12 {
	  font-size: 12px;
	}
	
</style>
